import { useMutation, useQueryClient } from "@tanstack/react-query";
import { revokeDelegation } from "../../api/delegation";
import { invalidateDelegationQueries } from "./delegationQueryKeys";

export const useRevokeDelegation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => revokeDelegation(id),
    onSuccess: () => {
      invalidateDelegationQueries(queryClient);
    },
  });
};
